import { create } from 'zustand';
import type { ApiSourceBundle } from '@interxfi/api-client/registry/api-source';
import type { ParsedSchema } from '@interxfi/j5-parse/types/parsed';

export function buildApiDocsVersionKey(bundle: ApiSourceBundle, registryVersion: string | undefined, version: string): string {
  return `${[bundle, registryVersion, version].filter(Boolean).join('|')}`;
}

type SchemaVersionState = Record<string, Record<string, ParsedSchema>>;

interface DocsState {
  mappedSchemasByVersion: SchemaVersionState;
  lastBuildTimeByVersion: Record<string, number>;
  addMappedSchema: (
    bundle: ApiSourceBundle,
    registryVersion: string | undefined,
    version: string,
    builtAt: string,
    name: string,
    schema: ParsedSchema,
  ) => void;
}

export const useDocsStore = create<DocsState>()((set) => ({
  lastBuildTimeByVersion: {},
  mappedSchemasByVersion: {},
  addMappedSchema: (bundle, registryVersion, version, builtAt, name, schema) =>
    set((state) => {
      const versionKey = buildApiDocsVersionKey(bundle, registryVersion, version);

      return {
        lastBuildTimeByVersion: {
          ...state.lastBuildTimeByVersion,
          [versionKey]: new Date(builtAt).getTime(),
        },
        mappedSchemasByVersion: {
          ...state.mappedSchemasByVersion,
          [versionKey]: {
            ...state.mappedSchemasByVersion[versionKey],
            [name]: schema,
          },
        },
      };
    }),
}));
